import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Loading from 'common/components/Loading';
import Text from 'common/components/Text';
import Heading from 'common/components/Heading';

import styles from './index.module.css';

const AISuggestions = ({
  className,
  isLoading,
  suggestions,
  isError,
  errorText,
  selectedSuggestion,
  onSuggestionClick,
}) => {
  if (isLoading) {
    return (
      <div className={classNames(styles.container, className)}>
        <div className={styles.loadingContent}>
          <Loading kind="secondary" size="small" />
          <p>Analysing business description</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={classNames(styles.container, className)}>
        <div className={styles.errorContent}>
          <Heading level="3" size="4" weight="regular" color="black">
            Couldn&apos;t find suggested sectors
          </Heading>
          {errorText && (
            <Text size="caption" color="rebranding-md-color-brand-black">
              {errorText}
            </Text>
          )}
        </div>
      </div>
    );
  }

  if (suggestions && Object.keys(suggestions).length > 0) {
    return (
      <div className={classNames(styles.container, className)}>
        <div className={styles.successContent}>
          <Heading level="3" size="4" weight="regular" color="black">
            Suggested sectors:
          </Heading>
          <div className={styles.suggestionsGrid}>
            {Object.entries(suggestions).map(
              ([sectorName, sectorSuggestions]) => (
                <div key={sectorName} className={styles.sectorGroup}>
                  <Text size="caption" weight="semiBold" color="black">
                    {sectorName}
                  </Text>
                  <div className={styles.subsectorGrid}>
                    {sectorSuggestions.map((suggestion, index) => {
                      const isSelected =
                        selectedSuggestion === suggestion.subsector;
                      return (
                        <button
                          key={suggestion.value || index}
                          type="button"
                          className={classNames(
                            styles.suggestionButton,
                            isSelected && styles.selected
                          )}
                          onClick={() =>
                            onSuggestionClick({
                              sector: suggestion.sector,
                              subsector: suggestion.subsector,
                            })
                          }
                        >
                          {suggestion.subsector}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

AISuggestions.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  suggestions: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        sector: PropTypes.string.isRequired,
        subsector: PropTypes.string.isRequired,
      })
    )
  ),
  isError: PropTypes.bool,
  errorText: PropTypes.string,
  selectedSuggestion: PropTypes.string,
  onSuggestionClick: PropTypes.func.isRequired,
};

AISuggestions.defaultProps = {
  isLoading: false,
  suggestions: {},
  isError: false,
  errorText: '',
  selectedSuggestion: null,
};

export default AISuggestions;
